import {GameClientUserState} from '@colonist/game-base-types'
import {GameState, NestedReadonly, PlayerColor} from '@colonist/game-states'
import {PlayerValidator} from './PlayerValidator'

export class GameValidator {
    private readonly gameState: NestedReadonly<GameState>
    private readonly userStates: NestedReadonly<GameClientUserState>[]
    private readonly playerValidators: Map<PlayerColor, PlayerValidator> = new Map()

    constructor(gameState: NestedReadonly<GameState>, userStates: NestedReadonly<GameClientUserState>[]) {
        this.gameState = gameState
        this.userStates = userStates

        for(const playerColorKey in this.gameState.playerStates) {
            const playerColor = Number(playerColorKey) as PlayerColor

            const playerState = this.gameState.playerStates[playerColor]
            if(playerState == undefined) continue

            const userState = this.userStates.find((playerUserState) => playerUserState.selectedColor === playerColor)
            if(userState == undefined) continue

            const playerStateController = new PlayerValidator(playerState, userState)
            this.playerValidators.set(playerStateController.color, playerStateController)
        }
    }

    getPlayerValidator(color: PlayerColor): PlayerValidator {
        const playerValidator = this.playerValidators.get(color)
        if(playerValidator == undefined) throw new Error(`PlayerValidator for color ${PlayerColor[color]} not found`)

        return playerValidator
    }
}
